import { makeStyles } from '@mui/styles';

export const useCartStyles = makeStyles((theme: any) => ({
  container: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  empty: {
    marginBottom: 20,
    marginTop: 20,
  },
  autoLoc: {
    width: '100%',
  },
  dates: {
    display: 'flex',
    flexDirection: 'column',
  },
  rigthCol: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    width: '35%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  totalCard: {
    backgroundColor: '#fff',
    borderRadius: 16,
    padding: 27,
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  bonusActive: {
    backgroundColor: theme.palette.primary.main,
    width: '33%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
    '&:hover': {
      backgroundColor: theme.palette.secondary.main,
      color: '#FFFFFF',
    },
  },
  btn: {
    width: '33%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  orderBtn: {
    width: 300,
    height: 50,
    [theme.breakpoints.down('sm')]: {
      width: 150,
    },
  },
  row: {
    marginTop: 10,
  },
  containerItems: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  containerForm: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    // alignItems: 'center',
    // justifyContent: 'space-between',
    marginBottom: theme.spacing(2),
  },
  radioGroup: {
    flexDirection: 'row',
  },
  containerTotal: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(3),
  },
  title: {
    fontSize: 24,
    color: '#181c32',
    fontWeight: 800,
    marginBottom: 27,
  },
  subTitle: {
    fontSize: 18,
    color: '#181c3280',
    fontWeight: 400,
    marginBottom: 18,
  },
  subTitleValue: {
    fontSize: 18,
    color: '#181c32',
    fontWeight: 400,
    marginBottom: 18,
  },
  containerValue: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  containerOffer: {
    marginTop: 13,
  },
  offerText: {
    fontSize: 16,
    color: '#2a3545',
    fontWeight: 400,
  },
  offerTextBlue: {
    fontSize: 16,
    color: '#006997',
    fontWeight: 400,
    cursor: 'pointer',
  },
  header: {
    padding: '20px 25px',
    backgroundColor: '#fff',
    borderRadius: 8,
    width: '100%',
    marginBottom: 24,
  },
  headerTitle: {
    fontSize: 26,
    fontWeight: 700,
    marginBottom: 0,
  },
  col: {
    padding: 0,
  },
}));
